import { Component, OnInit } from '@angular/core';
import { Subscription, interval } from "rxjs";

@Component({
  selector: 'app-bottom-footer',
  templateUrl: './bottom-footer.component.html',
  styleUrls: ['./bottom-footer.component.css']
})
export class BottomFooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  private setYear!: Subscription;

  constructor() { }

  ngOnInit(): void {
    this.setCurrentYear();
  }

  setCurrentYear(){
    this.setYear = interval(1000 * 60 * 60 * 24).subscribe(() => {
      this.updateYear();
    });
  }

  updateYear(): void {
    const newYear = new Date().getFullYear();
    if (this.currentYear !== newYear) {
      this.currentYear = newYear;
    }
  }

  ngOnDestroy(): void {
    if (this.setYear) {
      this.setYear.unsubscribe();
    }
  }
}
